import { Button } from '@monorepo/shared/componentsV2/Button/Button';
import { Loading } from '@monorepo/shared/componentsV2/Loading';
import { TabbableMenu } from '@monorepo/shared/componentsV2/menus/TabbableMenu';
import { Tooltip } from '@monorepo/shared/componentsV2/Tooltip';
import { KeyService } from '@monorepo/shared/KeyService';
import ColumnsIcon from '@svg/columns.svg';
import { QueryResponse } from 'mapistry-shared';
import React from 'react';
import styled from 'styled-components';
import { useCurrentViewCustomizeColumnsMenuOptions } from './useCurrentViewCustomizeColumnsMenuOptions';

const StyledButton = styled(Button)`
  white-space: nowrap;
`;

const StyledColumnsIcon = styled(ColumnsIcon)`
  /* Double selector in order to override mui button icon stylings (width and margin). */
  /* stylelint-disable-next-line no-duplicate-selectors */
  && {
    width: 0.75em;
    padding: 0.1rem;
    margin-right: 0;
  }
`;

const StyledTabbableMenu = styled(TabbableMenu)`
  width: 18rem;
  max-height: unset;
  overflow: clip;
`;

export function ViewCustomizeColumnsMenu({
  queryResult,
}: {
  queryResult?: QueryResponse;
}) {
  const { currentMenuOptions, isSaving, resetMenuState } =
    useCurrentViewCustomizeColumnsMenuOptions({
      queryResult,
    });
  const isLoading = isSaving || !queryResult;

  return (
    <StyledTabbableMenu
      onClose={resetMenuState}
      onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
        if (KeyService.isBackspaceKey(event.keyCode)) {
          resetMenuState();
        }
      }}
      buttonElement={
        <Tooltip
          placement="top-end"
          title="Customizing columns helps make your Report more relevant. Rearrange columns, change the names, and hide columns. Changes made will only apply to this Report."
        >
          <StyledButton
            variant="outlined"
            startIcon={
              isLoading ? <Loading size="small" /> : <StyledColumnsIcon />
            }
            disabled={!queryResult}
          >
            Customize columns
          </StyledButton>
        </Tooltip>
      }
      color="primary"
      options={currentMenuOptions}
    />
  );
}
